import React from 'react'
import { Environment } from 'infrastructure/api'

export const PartnerContext = React.createContext<string | undefined>(undefined)

type PartnerUploadData = {
  partnerKey?: string
  subject?: string
  gradeCode?: string
  environment?: Environment
}

export const PartnerUploadContext = React.createContext<PartnerUploadData>({})
